import React from 'react';
import ClinicalNoteForm from '../../../global/component/ClinicalNote/ClinicalNoteForm';
import { ClinicalNoteType } from '../../../global/entities/ClinicalNote/ClinicalNote';

const CounsellingNoteForm: React.FC = () => (
  <ClinicalNoteForm
    config={{
      noteType: ClinicalNoteType.Counselling,
      i18nPrefix: 'counsellingNote',
      returnPath: '/hcpPatientDashboard/medicalInformation',
    }}
  />
);

export default CounsellingNoteForm;
